import React from "react";
import styled, { css } from "styled-components";
import { useField } from "formik";

import Error from "./error";

const Wrapper = styled.div`
	margin-top: 1.25rem;
	width: 100%;

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	input[type="number"] {
		-moz-appearance: textfield;
	}

	.rc-container {
		display: flex;
		flex-direction: column;
	}

	.label-container {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin-bottom: 10px;
	}

	.label {
		color: #18191b;
		font-style: normal;
		font-weight: 600;
		font-size: 16px;
		font-family: Visby CF;
	}
	.sublabel {
		font-weight: 400;
		margin-left: 4px;
	}

	.input-field {
		font-family: Roboto;
		font-size: 16px;
		padding: 0 1.25rem;
		height: 50px;
		border: 1px solid grey;
		border-radius: 8px;
		// background-color: #f2f8ff;
		color: #18191b;
	}
	.input-field:focus {
		outline: none;
		border: 1px solid grey;
	}

	.adorment {
		position: relative;
		display: flex;
		flex: 1;
		align-items: center;
		border-radius: 8px;

		&__input {
			font-family: Roboto;
			font-size: 16px;
			padding: 0 1.25rem;
			height: 50px;
			width: 100%;
			border: 1px solid grey;
			border-radius: 8px;
			color: #18191b;
			// background-color: #f2f8ff;
			${(props) =>
				props.$adormentposition === "right"
					? css`
							padding-right: 2.25rem;
					  `
					: css`
							padding-left: 2.25rem;
					  `}
		}
		&__input:focus {
			outline: none;
			border: 1px solid grey; //#e4e5e7;
		}

		&__text {
			position: absolute;
			right: ${(props) => props.$adormentposition === "right" && "1rem"};
			left: ${(props) => props.$adormentposition === "left" && "1rem"};
		}
	}

	.error {
		font-family: Roboto;
		margin-left: 8px;
		color: red;
		font-size: 14px;
	}
`;

const MyTextField = ({ field, meta, label, sublabel = null, adorment = null, adormentposition = null, ...props }) => {
	return (
		<Wrapper className="input-wrapper" $adormentposition={adormentposition} {...props}>
			<div className="rc-container">
				{label && (
					<div className="label-container">
						<span className="label">{label}</span>
						{sublabel && <span className="sublabel">{sublabel}</span>}
					</div>
				)}

				<>
					{adorment ? (
						<>
							<div className="adorment">
								<input className="adorment__input" {...field} {...props} />
								<div className="adorment__text">{adorment}</div>
							</div>
							{meta.touched && meta.error && <Error text={meta.error} />}
						</>
					) : (
						<>
							<input className="input-field" {...field} {...props} />
							{meta.touched && meta.error && <Error text={meta.error} />}
						</>
					)}
				</>
			</div>
		</Wrapper>
	);
};

function Input(props) {
	const [field, meta] = useField(props);

	return <MyTextField name={props.name} label={props.label} field={field} meta={meta} {...props} />;
}

export default Input;
